<script>
    // core components
    import {Route, Router} from "svelte-routing";
    import GroupTable from "../../components/Cards/Group/GroupTable.svelte";
    import GroupForm from "../../components/Forms/Group/GroupForm.svelte";
    import GroupTree from "../../components/Cards/Group/GroupTree.svelte";
    export let location;
</script>

<Router url="groups">
    <Route component="{GroupTable}" />
    <Route path="table" component="{GroupTable}" />
    <Route path="create" component="{GroupForm}" />
    <Route path="edit" component="{GroupForm}" />
    <Route path="tree" component="{GroupTree}" />
</Router>
